// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__27yUu","lottie":"loading_lottie__cFeTA"};